import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'almanac-ui/Heading/Heading'
import Styles from './ConfirmReplaceDesignModal.module.scss'
import { useModals } from 'almanac-ui/Modal'
import { isVideo } from 'components/ImagePickerModal/utils'

interface Props {
  onConfirm: () => void
  mediaUrl: string
  mediaMimeType: string
  title: string
  description?: string
  confirmLabel?: string
}
export const ConfirmReplaceDesignModal = ({
  onConfirm,
  mediaUrl,
  mediaMimeType,
  title,
  description = 'Your selection will replace the current design',
  confirmLabel = 'Apply as Design',
}: Props) => {
  const { closeModal, closeStack } = useModals()

  const isMediaVideo = isVideo({ url: mediaUrl, type: mediaMimeType })

  return (
    <Modal.Root bodyClassName={Styles.modalBody} onPressOutside={closeStack}>
      <Modal.Header className={Styles.header}>
        <div className={Styles.headerContent}>
          <Heading level={2}>{title}</Heading>
          <Text>{description}</Text>
        </div>
      </Modal.Header>
      <Modal.Content>
        {isMediaVideo ? (
          <video src={mediaUrl} muted autoPlay controls className={Styles.media} />
        ) : (
          <img src={mediaUrl} alt="Replace Design" className={Styles.media} />
        )}
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={closeModal} size="lg" variant="tertiary">
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onConfirm} size="lg" variant="primary">
            {confirmLabel}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
